import { IconButton, Menu, MenuItem } from '@mui/material';
import { SwapVert } from '@mui/icons-material';
import { useContext, useEffect, useMemo, useState } from 'react';
import CondominiumContext from '../../contexts/CondominiumContext';
import { Condominium } from '../../entities';
import { Input, ScrollableContainer, Avatar } from '..';
import useStyles from './styles';
import { useCondominiums, useFetch } from '../../hooks';

interface SelectCondominiumMenuProps {
  open: boolean;
  anchorEl: Element | null;
  children: JSX.Element | JSX.Element[];
  onClose: () => void;
}

export const SelectCondominiumMenu = ({
  open,
  anchorEl,
  children,
  onClose,
}: SelectCondominiumMenuProps): JSX.Element => {
  const styles = useStyles();

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      PaperProps={{
        className: styles.menuContent,
      }}
      onClose={onClose}
    >
      <ScrollableContainer>{children}</ScrollableContainer>
    </Menu>
  );
};

export const SelectCondominium = (): JSX.Element => {
  const styles = useStyles();
  const { condominium, handleSelectCondominium } = useContext(CondominiumContext);

  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const [searchText, setSearchText] = useState('');
  const [openMenu, setOpenMenu] = useState(false);
  const [condominiums, setCondominiums] = useState<Condominium[]>([]);
  const condominiumsRepository = useCondominiums();
  const { data } = useFetch(condominiumsRepository.fetchAll);

  const handleMenuOpen = (event: React.MouseEvent) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenu(false);
    setSearchText('');
  };

  useEffect(() => {
    setCondominiums(data ?? []);
  }, [data]);

  const handleClickCondominium = (value: Condominium) => {
    handleSelectCondominium(value);
    handleMenuClose();
  };

  const getCondominiums = useMemo(() => {
    if (!searchText) {
      return condominiums.filter(({ id }) => id !== condominium?.id);
    }

    return condominiums.filter(
      ({ id, name }) => id !== condominium?.id && name.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, condominium, condominiums]);

  return condominium ? (
    <>
      <div className={styles.container}>
        <Avatar src={condominium.avatarUrl || undefined} />
        <div className={styles.info}>
          <div className={styles.title}>Condominío atual:</div>
          <div>{condominium.name}</div>
        </div>
        <div>
          <IconButton onClick={handleMenuOpen}>
            <SwapVert />
          </IconButton>
        </div>
      </div>
      <SelectCondominiumMenu open={openMenu} anchorEl={anchorEl} onClose={handleMenuClose}>
        <div className={styles.menuInfo}>
          <div className={styles.menuSearch}>
            <Input label="buscar condomínio" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
          </div>
          <div className={styles.menuGoTo}>Mudar para:</div>
        </div>
        <>
          {getCondominiums.map((cond) => (
            <MenuItem key={cond.id} className={styles.menuItem} divider onClick={() => handleClickCondominium(cond)}>
              <Avatar src={cond.avatarUrl || undefined} />
              <div className={styles.condominiumName}>{cond.name}</div>
            </MenuItem>
          ))}
        </>
      </SelectCondominiumMenu>
    </>
  ) : (
    <></>
  );
};

export default SelectCondominium;
